import setupBanner from '@/api/website/setup-banner'

import { baseState, baseMutations } from '@/store/mixins'


export const state = {
    ...baseState
}

export const mutations = {
    ...baseMutations
}

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                perPage: context.state.pagination.perPage,
            },
            attributes
        )
        return setupBanner.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },

    store(context, { id, data }) {
        if (id > 0) {
            return setupBanner.update(id, data)
        }
        return setupBanner.store(data)
    },
    destroy(context, id) {
        return setupBanner.destroy(id)
    },
}